import { render, staticRenderFns } from "./general-partial.vue?vue&type=template&id=1db9ba68"
import script from "./general-partial.vue?vue&type=script&lang=js"
export * from "./general-partial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports